// Harney Identity roles for app slug "dashboards" (harney-auth functions/_shared/apps.js).
export const ROLES = ['divtech_admin', 'harney_admin', 'harney_user', 'harney_viewer'] as const;
export type Role = (typeof ROLES)[number];
export const isRole = (v: unknown): v is Role => typeof v === 'string' && (ROLES as readonly string[]).includes(v);

export const ROLE_LABELS: Record<Role, string> = {
  divtech_admin: 'DivTech admin',
  harney_admin: 'Administrator',
  harney_user: 'User',
  harney_viewer: 'Viewer',
};

export const ALL_ROLES: readonly Role[] = ROLES;
export const ADMIN_ROLES: readonly Role[] = ['divtech_admin', 'harney_admin'];
/** Everyone but viewers: finance detail stays with users and admins by default. */
export const STAFF_ROLES: readonly Role[] = ['divtech_admin', 'harney_admin', 'harney_user'];
/** Production planning (Demand Workbench, Week Board): DivTech admins plus Harney admins and users (divtech_admin sees everything). */
export const PRODUCTION_ROLES: readonly Role[] = ['divtech_admin', 'harney_admin', 'harney_user'];
